import * as eventActions from 'Actions/events';
import { isLastTierOfLevel } from 'Utils/LevelTierCount';
import type {
  LevelCompletedEventAction,
  TierCompletedEventAction,
  TierSessionFinishedEventAction,
} from 'Types/EventTypes';

export type TierWon = {
  levelNumber: number;
  tierNumber: number;
  // Null while the level's tier count is not known: no level completion then.
  levelTierCount: number | null;
  playSessionId: string;
  // The play session whose finished event was last sent, if any.
  lastFinishedPlaySessionId: string | null;
};

export type TierWonEventAction =
  | TierSessionFinishedEventAction
  | TierCompletedEventAction
  | LevelCompletedEventAction;

// The events a Sight Reading tier won sends, in the order they must reach the
// server. The play session's finished event comes first: the server ends the
// session `finished` on it, and refuses it once the session's tier completion is
// stored. Then the tier completion, and the level completion on the level's last
// tier. The finished event goes once per play session: a session already finished
// (the last one sent) sends no second one. Play sessions follow one another (a new
// one on every tier change or replay), so the last one sent is enough to tell.
export const tierWonEventActions = ({
  levelNumber,
  tierNumber,
  levelTierCount,
  playSessionId,
  lastFinishedPlaySessionId,
}: TierWon): TierWonEventAction[] => [
  ...(playSessionId !== lastFinishedPlaySessionId
    ? [eventActions.tierSessionFinishedEventAction(levelNumber, tierNumber, playSessionId)]
    : []),
  eventActions.tierCompletedEventAction(levelNumber, tierNumber, playSessionId),
  ...(isLastTierOfLevel(tierNumber, levelTierCount)
    ? [eventActions.levelCompletedEventAction(levelNumber, playSessionId)]
    : []),
];
